module.exports = __webpack_public_path__ + "static/media/logo123.5d343063.png";